import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';

import { CommonMediaQueries, LetModule, MediaScreenService } from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';

import { Role } from '@pp/core/entities';
import { PermissionsStore } from '@pp/core/store';

import { NavComponent } from '../../nav/nav.component';
import { RateConditionsComponent } from '../../rate-conditions';
import { TeamSelectorComponent } from '../../team-selector/team-selector.component';

@Component({
  imports: [AsyncPipe, LetModule, TranslateModule, NavComponent, TeamSelectorComponent, RateConditionsComponent],
  selector: 'pp-menu-dialog',
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogComponent {
  readonly #mediaScreenService = inject(MediaScreenService);
  readonly navItemClicked = output<Event>();

  readonly roleEnum = Role;
  permissions = inject(PermissionsStore);

  breakpoints$ = combineLatest({
    isTablet: this.#mediaScreenService.mediaMatcher(CommonMediaQueries.MD),
  });
}
